<template>
  <div class="panel-body">
    <not-affiliate v-if="checkAffiliate"></not-affiliate>
    <div v-else>
      <div>
        <fieldset class="border">
          <legend class="border" v-if="reward"><b>{{ reward.title }}</b></legend>
          <div class="text-left">
            <div v-if="reward" v-html="reward.content"></div>
          </div>
        </fieldset>
      </div>
      <br>
      <div>
        <fieldset class="border">
          <legend class="border">
            <b>紹介者URL</b>
          </legend>
          <div class="text-left">
            <button type="button" class="btn btn-info" v-on:click="copyText">コピー</button>
            <br>
            <br>
            <input id="affiliate_url" class="form-control" type="text" v-model="getUrl" readonly>
          </div>
        </fieldset>
      </div>
      <br>
      <div>
        <fieldset class="border">
          <legend class="border" v-if="rewardSample">
            <b>{{ rewardSample.title }}</b>
          </legend>
          <div class="text-left">
            <button type="button" class="btn btn-info" v-on:click="copyTextArea">コピー</button>
            <br>
            <br>
            <textarea id="affiliate_sample" class="form-control" cols="40" rows="10" maxlength="500" v-if="rewardSample" v-model="rewardSample.content">
            </textarea>
          </div>
        </fieldset>
      </div>
      <br>
      <div>
        <fieldset class="border">
          <legend class="border"><b>成果条件</b></legend>
          <div class="text-left">
            <dl class="row" v-for="(item, index) in rewordCondition" :key="index">
              <dt class="col-sm-3 text-truncate">{{ item.title }}</dt><dd>{{ item.content }}</dd>
            </dl>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>
<script>
import RewradService from '@/services/rewardservice'
import NotAffiliate from '@/view/affiliate/NotAffiliate'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    NotAffiliate
  },

  data () {
    return {
      err: null,
      reward: null,
      rewordCondition: {},
      rewardSample: null,
      loader: null,
      affiliateUrl: `${process.env.NODE_DOMAIN}/signup?SellerId=`
    }
  },

  created () {
    this.getRewardDiscription()
  },

  computed: {
    getUrl () {
      return this.affiliateUrl + this.$store.getters.getUser.sellerId
    },
    checkAffiliate () {
      const countryCodeEnable = ['jp', 'cn']
      return !countryCodeEnable.includes(this.$store.getters.getUser.countryCode)
    }
  },

  methods: {
    async getRewardDiscription () {
      let self = this
      RewradService.getRewardDiscription()
        .then((response) => {
          self.reward = response['rewards'].filter(discription => discription.kind === 'reward')[0]
          self.rewordCondition = response['rewards'].filter(discription => discription.kind === 'reword_condition')
          self.rewardSample = response['rewards'].filter(discription => discription.kind === 'reword_sample')[0]
        })
        .catch((error) => {
          self.err = error
        })
        .finally(() => {
          if (this.$route.params.tab === 'top') {
            this.$events.fire('done')
          }
        })
    },
    copyText () {
      var copyText = document.querySelector('#affiliate_url')
      copyText.select()
      document.execCommand('copy')
    },
    copyTextArea () {
      var copyText = document.querySelector('#affiliate_sample')
      copyText.select()
      document.execCommand('copy')
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'top') {
      let logParams = {
        name: eventCode.affiliate.top_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/affiliate/Top.vue